import client from 'core/axios';
import RequestMethod from 'core/axios/RequestMethod';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';

export const updateLoginMethod = ({ id, type, data, version = 'v1' } = {}) => {
  let url = `${version}/third-party-accounts/${id}/`;
  if (type === 'email') {
    url = `${version}/sl_users/${type}s/${id}/`;
  }

  client
    .request({
      url,
      data,
      method: RequestMethod.PATCH,
    })
    .then(handleJSONResponse)
    .catch(handleError);
};

export const updateNotificationPreference = ({ data, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/notifications/preference/`,
      method: RequestMethod.POST,
      data,
    })
    .then(handleJSONResponse)
    .catch(handleError);

/**
 * Send Verification Code to the Phone Number
 *
 * @param {String} data.number - phone number
 */
export const sendPhoneVerificationCode = ({ data, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/sl_users/phones/send-verification-code/`,
      method: RequestMethod.POST,
      data,
    })
    .then(handleJSONResponse)
    .catch(handleError);

/**
 * Add Phone Number for Verification
 *
 * @param {String} data.number - phone number
 * @param {String} data.code - verification code
 */
export const addPhoneNumber = ({ data, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/sl_users/phones/`,
      method: RequestMethod.POST,
      data,
    })
    .then(handleJSONResponse)
    .catch(handleError);

/**
 * Get Phone Numbers
 */
export const getPhoneNumberList = ({ version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/sl_users/phones/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

/**
 * Update Phone Notification Preference
 *
 * @param {String} phoneUuid - Phone number unique Id
 * @param {Boolean} data.receiveNotifications
 */
export const updatePhoneDetails = ({ data, phoneUuid, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/sl_users/phones/${phoneUuid}/`,
      method: RequestMethod.PATCH,
      data,
    })
    .then(handleJSONResponse)
    .catch(handleError);
